/**
 * Created by fers on 26.09.15.
 */

import { declareEntity } from '../fw/MetaDataHelper';
import { v4 as uuidv4 } from 'uuid';

export default declareEntity({
    name: "loggers",
    graphQL: "logger",
    entity: 'loggers',
    description: "Logger",
    storageType: 'silo',
    defaultOrder: [['createdAt', 'asc']],
    userEditable: false,
    fields: (types) => { return {
        id: {
            name: "Logger ID",
            type: "id",
            defaultValue: () => {
                return uuidv4();
            },
            primaryKey: true,
            required: true,
        },
        organisation: {
            name: "Organisation",
            type: "relation",
            to: () => types['organisations'],
        },
        instance: {
            name: "Instance",
            type: "relation",
            to: () => types['instances'],
        },
        channel: {
            name: "Application",
            type: "relation",
            to: () => types['channels'],
        },
        flow: {
            name: "Flow",
            type: "relation",
            to: () => types['flows'],
        },
        flowInvocation: {
            name: "Flow Invocation",
            type: "relation",
            to: () => types['flowInvocations'],
        },
        flowDef: {
            name: "Flow Definition",
            type: "relation",
            to: () => types['flowDefs'],
        },
        job: {
            name: "Job",
            type: "relation",
            to: () => types['jobs'],
        },
        channelDef: {
            name: "Application Def",
            type: "relation",
            to: () => types['channelDefs'],
        },
        message: {
            name: "Message",
            type: "string"
        },
        messagePreview: {
            name: "Message Preview",
            type: "string",
            userEditable: false,
            import: false,
            export: false,
            controllerFn: "getMessagePreview",
        },
        createdAt: {
            name: "Created At",
            type: "datetime",
            defaultValue: () => {
                return new Date();
            },
            userEditable: false,
        }
    }; }
});
